// extracted by mini-css-extract-plugin
export var activeIndex = "EventOurServices-module--activeIndex--4ee03";
export var cMarginTop = "EventOurServices-module--c-margin-top--b6992";
export var cPadding = "EventOurServices-module--c-padding--566c1";
export var cPaddingBottom = "EventOurServices-module--c-padding-bottom--8d79a";
export var cPaddingTop = "EventOurServices-module--c-padding-top--86af9";
export var content = "EventOurServices-module--content--d89ad";
export var date = "EventOurServices-module--date--2a5b2";
export var disabled = "EventOurServices-module--disabled--40ca9";
export var ellipsis = "EventOurServices-module--ellipsis--ca19e";
export var eventImage = "EventOurServices-module--eventImage--5d8ea";
export var featuredSection = "EventOurServices-module--featuredSection--25553";
export var globalSpacing = "EventOurServices-module--global-spacing--17a38";
export var globalSpacingBottom = "EventOurServices-module--global-spacing-bottom--d3297";
export var globalSpacingTop = "EventOurServices-module--global-spacing-top--7aed7";
export var head = "EventOurServices-module--head--f6416";
export var image = "EventOurServices-module--image--679b3";
export var imageWrapper = "EventOurServices-module--imageWrapper--129b9";
export var img = "EventOurServices-module--img--54b52";
export var index = "EventOurServices-module--index--50cdc";
export var listItem = "EventOurServices-module--listItem--c492f";
export var mainImg = "EventOurServices-module--mainImg--7d90b";
export var maxWidth = "EventOurServices-module--max-width--708ea";
export var mobileSlider = "EventOurServices-module--mobileSlider--0c982";
export var mobileSliderContainer = "EventOurServices-module--mobileSliderContainer--c19c6";
export var navButton = "EventOurServices-module--navButton--79666";
export var pagination = "EventOurServices-module--pagination--19d80";
export var para = "EventOurServices-module--para--3e2b2";
export var serviceContainer = "EventOurServices-module--serviceContainer--28c61";
export var serviceMainContainer = "EventOurServices-module--serviceMainContainer--a5df8";
export var styleTick = "EventOurServices-module--styleTick--ef2cc";
export var tag = "EventOurServices-module--tag--f092d";
export var tagWrapper = "EventOurServices-module--tagWrapper--269f0";
export var title = "EventOurServices-module--title--53476";
export var titleMobile = "EventOurServices-module--titleMobile--65ec0";